
import Vue from 'vue';
import Component from 'vue-class-component';

/**
 * e-İcraPro+ giriş kartı.
 *
 * Eskiden imza servisi durum kartının (Başlat/Durdur/Yenile) altındaydı. O kart
 * kaldırıldı: jar yalnızca imzalama yapıyor, kullanıcı yönetmiyordu ve eski
 * imzacıdan kalmaydı. Geriye tek gerçek eylem kaldı — tarayıcıda e-İcraPro+ açmak.
 */
@Component({})
export default class EicraproLaunchCard extends Vue {
  openNewEicrapro() {
    // Tarayıcıyı Electron ana süreci açıyor; proxy'deki /openBrowser ucu shell'e devrediyor.
    this.$http.get('https://imza.eicrapro.com:6090/openBrowser?url=https://cloud.zirve-bilgisayar.com/eicrapro/takip-hazirla');
  }
}
